import {Component, Input} from '@angular/core';
import {DateHelperService} from '../../../../../shared/services/general';
import {ClientWithExtras} from '../../../../shared/models/order-entry/client';
import {PatientSearchWithoutCollections} from '../../../../shared/models/order-entry/patient';
import {Physician} from '../../../../shared/models/order-entry/physician';
import {Order} from '../../models/order';

@Component({
    selector: 'app-order-header',
    templateUrl: './order-header.component.html',
    styleUrls: ['./order-header.component.scss'],
})
export class OrderHeaderComponent {
    @Input() public order = new Order();
    @Input() public client = new ClientWithExtras();
    @Input() public patient = new PatientSearchWithoutCollections();
    @Input() public physician = new Physician();

    constructor(
        public dateHelper: DateHelperService,
    ) { }

    public format(dateString?: Date, utc: boolean = false) {
        if(!dateString) return '';
        if (utc) return this.dateHelper.dateWithFormat(dateString, "MM/DD/YYYY hh:mm a");
        return this.dateHelper.dateWithFormatWithoutUtc(dateString, "MM/DD/YYYY hh:mm a")
    }

    public get Client() {
        return this.patient ? (this.patient.client ? this.patient.client.name : '') : '';
    }

    public get PatientFullName() {
        return this.patient ? `${this.patient.firstName} ${this.patient.middleName
            ? this.patient.middleName : ''} ${this.patient.lastName}` : '';
    }

    public get DOB() {
        return this.patient && this.patient.birthDate ? `(${this.dateHelper.dateWithFormatWithoutUtc(this.patient.birthDate as Date, 'LL')})` : '';
    }

    public get Gender() {
        return this.patient ? this.patient.gender : '';
    }

    public get Room() {
        return this.patient ? (this.patient.room ? this.patient.room.name : '') : '';
    }

    public get Unit() {
        if (!this.patient) {
            return '';
        }
        if (!this.patient.unit) {
            return '';
        }
        return this.patient.unit.name;
    }

    public get CollectionSites() {
        return this.order.collectionSites ? this.order.collectionSites.map(cs => cs.name).join(', ') : '';
    }

    public get Physician() {
        if (!this.physician) {
            return '';
        }
        return this.physician.lastName ? `${this.physician.lastName}, ${this.physician.firstName}` : '';
    }

    public get PatientPrimaryPhysician() {
        if (!this.patient) {
            return '';
        }
        return (this.patient as any).primaryPhysician ? `${(this.patient as any).primaryPhysician.lastName}, ${(this.patient as any).primaryPhysician.firstName}` : '';
    }

    public get PatientAddress() {
        if (!this.patient) {
            return '';
        }
        if (!this.patient.zipCode) {
            return this.patient.address ? this.patient.address : '';
        }
        return `${this.patient.address}, ${this.patient.zipCode.city},
        ${this.patient.zipCode.state} ${this.patient.zipCode ? this.patient.zipCode.code : ''}`;
    }

  public get ClientAddress() {
    if (!this.client) {
      return '';
    }
    if (!this.client.zipCode) {
      return this.client.address ? this.client.address : '';
    }
    return `${this.client.address}, ${this.client.zipCode.city},
        ${this.client.zipCode.state} ${this.client.zipCode ? this.client.zipCode.code : ''}`;
  }
}
